import React, { useState } from 'react'
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
  } from "@mui/material";
import { PeriodFilterProps } from '../../types/types';
import { TranslationEnum, usePortalTranslation } from '../../../../providers/TranslationProvider';
import { useSelector } from 'react-redux';
import store from '../../../../stateManagement/store';

const PeriodFilter = (props: PeriodFilterProps) => {
    const koFilter = useSelector(() => Boolean(store.getState()?.fileFormat?.config?.useBusinessCalendar));
    const { translate } = usePortalTranslation();
    const handleChangePeriod = (event: SelectChangeEvent) => {
        props.setPeriod(event.target.value);
    };
    return (
        <div className="dates-periodrange">
            <FormControl>
                <InputLabel id="demo-simple-select-label">{translate(TranslationEnum.common_portal,koFilter? "KO Filter" : "Period")}</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={props.period}
                label={translate(TranslationEnum.common_portal,"Period")}
                onChange={handleChangePeriod}
                >
                {props.periodOptions.map((option: any) => (
                    <MenuItem key={option} value={option}>
                        {koFilter? "KO Month" : "Period"} {option}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
            <FormControl>
                <InputLabel id="demo-simple-select-label">{translate(TranslationEnum.common_portal,"Year")}</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={props.year}
                label={translate(TranslationEnum.common_portal,"Year")}
                onChange={props.handleChangeYear}
                >
                    {props.yearOptions.map((year) => {
                        return <MenuItem value={year}>{year}</MenuItem>
                    })}
                </Select>
            </FormControl>
            </div>
    )
}

export default PeriodFilter